import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AlertComponent } from '../../shared/components/alert/alert.component';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { ValueCardComponent } from '../../shared/components/value-card/value-card.component';
import { OrdersService } from '../../core/services/order/order.service';
import { ParsedStats, StatsResponse } from '../../core/models/order/order-statistics.model';
import { parseStatistics } from '../../core/helpers/order-statistics.helper';
import { formatBRLFromCents } from '../../core/helpers/currency.helper';
import { currentHourBR } from '../../core/helpers/date-timer.helper';

interface SalesChannel {
  id: string | null;
  label: string;
}

interface SellerTypeOption {
  id: '1p' | '3p' | null;
  label: string;
}

const SALES_CHANNELS: SalesChannel[] = [
  { id: null, label: 'Todos os canais' },
  { id: 'site-b2c', label: 'Site B2C' },
  { id: 'app-vendedor', label: 'App do vendedor' },
  { id: 'site-b2b', label: 'Site B2B' },
  { id: 'site-incentivos', label: 'Site incentivos' },
  { id: 'app-cliente', label: 'App do cliente' },
  { id: 'premium-seller', label: 'Premium Seller' },
];

const SELLER_TYPES: SellerTypeOption[] = [
  { id: null, label: 'Todos' },
  { id: '1p', label: '1P' },
  { id: '3p', label: '3P' },
];

@Component({
  selector: 'app-revenue-overview',
  standalone: true,
  imports: [AlertComponent, LoadingComponent, ValueCardComponent],
  templateUrl: './revenue-overview.component.html',
  styleUrl: './revenue-overview.component.scss',
})
export class RevenueOverviewComponent implements OnInit, OnDestroy {
  initialLoading = true;
  refreshing = false;
  error?: string;
  parsed?: ParsedStats;

  channels = SALES_CHANNELS;
  selectedChannelId: string | null = null;

  sellerTypes = SELLER_TYPES;
  selectedSellerType: '1p' | '3p' | null = null;

  protected readonly formatBRLFromCents = formatBRLFromCents;
  protected readonly currentHourBR = currentHourBR;

  private fetchSub?: Subscription;

  constructor(private orderService: OrdersService) {}

  ngOnInit(): void {
    this.fetchStatistics();
  }

  ngOnDestroy(): void {
    this.fetchSub?.unsubscribe();
  }

  onFilterChange(): void {
    this.fetchStatistics();
  }

  private fetchStatistics(): void {
    this.fetchSub?.unsubscribe();
    this.refreshing = true;
    this.error = undefined;

    this.fetchSub = this.orderService
      .statistics(this.selectedChannelId ?? undefined, this.selectedSellerType ?? undefined)
      .subscribe({
        next: (data: StatsResponse) => {
          this.parsed = parseStatistics(data);
          this.initialLoading = false;
          this.refreshing = false;
        },
        error: (err) => {
          this.error = 'Não foi possível carregar os dados de faturamento.';
          this.initialLoading = false;
          this.refreshing = false;
          console.error(err);
        },
      });
  }
}
